$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");
        $(".header_sec").removeClass("normalMenu");

    } else {
        $(".header_sec").removeClass("fixed");
        $(".header_sec").addClass("normalMenu");
    }
    
});

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 150) {
        $(".chats").addClass("actv");

    } else {
        $(".chats").removeClass("actv");
    }
   if (scroll >= 250) {
        $(".backTop").addClass("actv");

    } else {
        $(".backTop").removeClass("actv");
    } 
});


$(document).ready(function() {
  var owl = $('.homecaro .owl-carousel');
  owl.owlCarousel({
    margin: 0,
    dots: false,
    autoplay: true,
    nav: false,
    loop: true,
    
    // Fade options
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',

    responsive: {
      0: {
        items: 1,
      },
      1200: {
        items: 1,
      }
    }
  });
});

















$(document).ready(function() {
var owl = $('.storiescaro.owl-carousel');
  owl.owlCarousel({
    margin:15,
    dots: false,
    dotsEach: false,
    autoplay: false,
    nav: true,
    loop: false,
    navText: [
      '<i class="fa-solid fa-angle-left"></i>',
      '<i class="fa-solid fa-angle-right"></i>'
    ],
    responsive: {
      1: {	
        items: 1
      },
      500: {
        items: 2
      },
      700: {
        items: 2
      },
      1000: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.countcaro.owl-carousel');
  owl.owlCarousel({
    margin:15,
    dots: false,
    dotsEach: false,
    autoplay: false,
    nav: true,
    loop: false,
    navText: [
      '<i class="fa-solid fa-angle-left"></i>',
      '<i class="fa-solid fa-angle-right"></i>'
    ],
    responsive: {
      1: {	
        items: 1
      },
      500: {
        items: 2
      },
      700: {
        items: 2
      },
      1000: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.newscaro.owl-carousel');
  owl.owlCarousel({
    margin:15,
    dots: false,
    dotsEach: false,
    autoplay: false,
    nav: true,
    loop: false,
    navText: [
      '<i class="fa-solid fa-angle-left"></i>',
      '<i class="fa-solid fa-angle-right"></i>'
    ],
    responsive: {
      1: {	
        items: 1
      },
      700: {
        items: 2
      },
      1000: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});













